import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import OptionalModules from '.';

const paths = {
  optionalModules: '/settings/optional-modules',
};

export default [
  <RouteIfRights
    exact
    path={paths.optionalModules}
    component={OptionalModules}
    key={paths.optionalModules}
    rights="admin"
  />,
];
